// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__jovXX","description":"styles_description__UTc0L","skeleton-animation":"styles_skeleton-animation__V9WoL"};